import Button from "@metacrm/metacrm-material-ui/dist/Button";
import { Box, Grid } from "@mui/material";
import PureModal from "components/PureModal";
import React, { useEffect, useRef, useState } from "react";
import { StyledLabel, StyledDashBar } from "./FilterModal.styles";
import { cloneDeep, isEqual } from "lodash-es";
import AutoCompleteDropdown from "@metacrm/metacrm-material-ui/dist/AutoCompleteDropdown";
import Switch from "@metacrm/metacrm-material-ui/dist/Switch";
import IconTooltip from "@metacrm/metacrm-material-ui/dist/IconTooltip";
import {
  useFetchEntityConfig,
  useFetchKolList,
} from "features/metadesk/redux/hooks";
import { useOutletContext } from "react-router";
import { useSelector } from "react-redux";
import { selectEcosystemName } from "features/metadesk/redux/entityConfig/entityConfig.selector";
import InputField from "@metacrm/metacrm-material-ui/dist/InputField";
import _ from "lodash";
import { useIntl } from "react-intl";

export default function FilterModal({ open, handleClose, ...props }) {
  const { formatMessage } = useIntl();
  const [entityName] = useOutletContext();
  const ecosystemName = useSelector(selectEcosystemName);
  const { kolListFilter: filter, updateKolListFilter: setFilter } =
    useFetchKolList();

  const initFilterData = {
    verified: false,
    xFollowers: [null, null],
    categories: [],
    etr: [null, null],
    vtr: [null, null],
    originalTweetsRatio: [null, null],
    language: [],
    location: [],
  };
  const firstTimeRef = useRef(true);

  const [tempFilter, setTempFilter] = useState(cloneDeep(initFilterData));

  useEffect(() => {
    try {
      setTempFilter({
        ...initFilterData,
        ...filter,
      });
    } catch (e) {
      console.log(e);
    }
  }, [filter]);

  function handleChange(key, newValue) {
    setTempFilter({ ...tempFilter, [key]: newValue });
  }

  function applyFilter() {
    const updatedFields = {};
    Object.keys(tempFilter).forEach((key) => {
      if (
        !isEqual(tempFilter[key], initFilterData[key]) ||
        (filter[key] &&
          filter[key]?.length > 0 &&
          !isEqual(tempFilter[key], filter[key]))
      ) {
        updatedFields[key] = tempFilter[key];
      }
    });
    // 更新過的字段才會被應用到 filter 中
    setFilter({ ...filter, ...updatedFields, page: 1 });
    handleClose();
    firstTimeRef.current = false;
  }

  useEffect(() => {}, []);

  const { entityConfig } = useFetchEntityConfig();

  const categoriesOptions = [
    {
      color: "#C5E3FF",
      label: "DeFi",
      type: "category",
      value: "defi",
    },
    {
      color: "#C5E3FF",
      label: "Holder",
      type: "category",
      value: "holder",
    },
    {
      color: "#F1E5FF",
      label: "Whale",
      type: "category",
      value: "whale",
    },
    {
      color: "#F1E5FF",
      label: "NFT",
      type: "category",
      value: "nft",
    },
    {
      color: "#FEE",
      label: "Gaming",
      type: "category",
      value: "gaming",
    },
    {
      color: "#FFE8B7",
      label: "Opinion Leader",
      type: "category",
      value: "opinionLeader",
    },
    {
      color: "#FFE8B7",
      label: "SocialFi",
      type: "category",
      value: "socialFi",
    },
  ];

  const languageOptions = [
    { label: "English", value: "en" },
    { label: "Chinese", value: "zh" },
    { label: "Japanese", value: "jp" },
    { label: "Korean", value: "ko" },
    { label: "French", value: "fr" },
    { label: "Spanish", value: "es" },
    { label: "German", value: "de" },
    { label: "Italian", value: "it" },
    { label: "Russian", value: "ru" },
    { label: "Portuguese", value: "pt" },
  ];

  const locationOptions = [
    { label: "Global", value: "global" },
    { label: "Taiwan", value: "taiwan" },
    { label: "India", value: "india" },
    { label: "United States", value: "usa" },
    { label: "Brazil", value: "brazil" },
    { label: "Russia", value: "russia" },
    { label: "Japan", value: "japan" },
    { label: "South Korea", value: "southKorea" },
  ];

  function handleValueBlur(e, filterKey) {
    const inputValue = Number(e.target.value.replace(/[^0-9]/g, "")); // 去除非數字的符號

    let max;
    if (filterKey !== "xFollowers") {
      max = 100;
    }

    let arr = [...tempFilter[filterKey]];
    if (inputValue > max) {
      arr[1] = max;
    }
    if (!arr.some((v) => v === null || v === "") && arr[0] > arr[1]) {
      [arr[0], arr[1]] = [arr[1], arr[0]];
    }
    handleChange(filterKey, arr);
  }

  return (
    <PureModal
      open={open}
      closeBtn={false}
      onClose={handleClose}
      sx={{ zIndex: 10000 }}
      maxWidth="848px"
      {...props}
    >
      <Box
        p="24px 24px 24px 32px"
        borderBottom="1px solid #E6E6E6"
        fontSize={20}
        fontWeight={700}
        className="item-flex"
        justifyContent="space-between"
      >
        <Box>{formatMessage({ id: "kol.filters.title" })}</Box>
        <i
          className="meta-crm-icon-ic_cancel font-size-20"
          onClick={handleClose}
          style={{ cursor: "pointer" }}
        />
      </Box>
      <Box
        p="24px 32px"
        display="flex"
        maxHeight="calc(85vh - 141px)"
        overflow="auto"
      >
        <Box flex={1}>
          <StyledLabel>
            {formatMessage({ id: "kol.filters.followersCount" })}
          </StyledLabel>
          <Box
            sx={{
              mt: "20px",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <InputField
              value={tempFilter.xFollowers[0] && tempFilter.xFollowers[0]}
              onBlur={(e) => handleValueBlur(e, "xFollowers")}
              placeholder={formatMessage({
                id: "global.filter.placeholder.min",
              })}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, "");
                handleChange("xFollowers", [
                  Number(value),
                  tempFilter.xFollowers[1],
                ]);
              }}
            />
            <StyledDashBar />
            <InputField
              value={tempFilter.xFollowers[1] && tempFilter.xFollowers[1]}
              placeholder={formatMessage({
                id: "global.filter.placeholder.max",
              })}
              onBlur={(e) => handleValueBlur(e, "xFollowers")}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, "");
                handleChange("xFollowers", [
                  tempFilter.xFollowers[0],
                  Number(value),
                ]);
              }}
            />
          </Box>
          <StyledLabel sx={{ marginTop: "32px" }}>
            {formatMessage({ id: "kol.filters.verifiedAccount" })}
          </StyledLabel>
          <Switch
            iosSwitch
            onChange={(e) => handleChange("verified", e)}
            checked={tempFilter.verified}
          />
          <StyledLabel sx={{ marginTop: "32px" }}>
            {formatMessage({ id: "kol.filters.category" })}
          </StyledLabel>
          <AutoCompleteDropdown
            value={tempFilter.categories}
            options={categoriesOptions}
            isTag
            multiple
            onChange={(e, v) => handleChange("categories", v)}
          />
          <StyledLabel sx={{ marginTop: "32px" }}>
            {formatMessage({ id: "kol.filters.language" })}
          </StyledLabel>
          <AutoCompleteDropdown
            value={tempFilter.language}
            options={languageOptions}
            multiple
            onChange={(e, v) => handleChange("language", v)}
          />
          <StyledLabel sx={{ marginTop: "32px" }}>
            {formatMessage({ id: "kol.filters.location" })}
          </StyledLabel>
          <AutoCompleteDropdown
            value={tempFilter.location}
            options={locationOptions}
            multiple
            onChange={(e, v) => handleChange("location", v)}
          />
        </Box>
        <Box width="1px" mx="32px" bgcolor="#E2E0E0"></Box>
        <Box flex={1}>
          <StyledLabel>
            {formatMessage({ id: "kol.filters.engagementRate" })}
            <IconTooltip
              content={formatMessage({
                id: "global.header.etr.tooltip",
              })}
            />
          </StyledLabel>
          <Box
            sx={{
              mt: "20px",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <InputField
              value={tempFilter.etr[0] ? `${tempFilter.etr[0]}%` : ""}
              onBlur={(e) => handleValueBlur(e, "etr")}
              placeholder={`${formatMessage({
                id: "global.filter.placeholder.max",
              })} %`}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, "");
                handleChange("etr", [Number(value), tempFilter.etr[1]]);
              }}
            />
            <StyledDashBar />
            <InputField
              value={tempFilter.etr[1] ? `${tempFilter.etr[1]}%` : ""}
              placeholder={`${formatMessage({
                id: "global.filter.placeholder.max",
              })} %`}
              onBlur={(e) => handleValueBlur(e, "etr")}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, "");
                handleChange("etr", [tempFilter.etr[0], Number(value)]);
              }}
            />
          </Box>
          <StyledLabel sx={{ marginTop: "32px" }}>
            {formatMessage({ id: "kol.filters.viewThroughRate" })}
            <IconTooltip
              content={formatMessage({
                id: "global.header.vtr.tooltip",
              })}
            />
          </StyledLabel>
          <Box
            sx={{
              mt: "20px",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <InputField
              value={tempFilter.vtr[0] ? `${tempFilter.vtr[0]}%` : ""}
              onBlur={(e) => handleValueBlur(e, "vtr")}
              placeholder={`${formatMessage({
                id: "global.filter.placeholder.max",
              })} %`}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, "");
                handleChange("vtr", [Number(value), tempFilter.vtr[1]]);
              }}
            />
            <StyledDashBar />
            <InputField
              value={tempFilter.vtr[1] ? `${tempFilter.vtr[1]}%` : ""}
              placeholder={`${formatMessage({
                id: "global.filter.placeholder.max",
              })} %`}
              onBlur={(e) => handleValueBlur(e, "vtr")}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, "");
                handleChange("vtr", [tempFilter.vtr[0], Number(value)]);
              }}
            />
          </Box>
          <StyledLabel sx={{ marginTop: "32px" }}>
            {formatMessage({ id: "kol.filters.originalTweetsRatio" })}{" "}
            <IconTooltip
              content={formatMessage({
                id: "global.header.originalTweetsRatio.tooltip",
              })}
            />
          </StyledLabel>
          <Box
            sx={{
              mt: "20px",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <InputField
              value={
                tempFilter.originalTweetsRatio[0]
                  ? `${tempFilter.originalTweetsRatio[0]}%`
                  : ""
              }
              onBlur={(e) => handleValueBlur(e, "originalTweetsRatio")}
              placeholder={`${formatMessage({
                id: "global.filter.placeholder.max",
              })} %`}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, "");
                handleChange("originalTweetsRatio", [
                  Number(value),
                  tempFilter.originalTweetsRatio[1],
                ]);
              }}
            />
            <StyledDashBar />
            <InputField
              value={
                tempFilter.originalTweetsRatio[1]
                  ? `${tempFilter.originalTweetsRatio[1]}%`
                  : ""
              }
              placeholder={`${formatMessage({
                id: "global.filter.placeholder.max",
              })} %`}
              onBlur={(e) => handleValueBlur(e, "originalTweetsRatio")}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, "");
                handleChange("originalTweetsRatio", [
                  tempFilter.originalTweetsRatio[0],
                  Number(value),
                ]);
              }}
            />
          </Box>
        </Box>
      </Box>
      <Box
        p="16px 32px"
        boxShadow="0px 4px 20px 0px rgba(0, 0, 0, 0.10)"
        className="item-flex"
        justifyContent="space-between"
      >
        <Box
          sx={{
            color: "#7B61FF",
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => setTempFilter(cloneDeep(initFilterData))}
        >
          {formatMessage({ id: "global.btn.clearFilter" })}
        </Box>

        <Box className="item-flex" gap="12px">
          <Button onClick={handleClose} variant="outlined">
            {formatMessage({ id: "global.btn.cancel" })}
          </Button>
          <Button
            onClick={applyFilter}
            disabled={
              isEqual(tempFilter, initFilterData) && firstTimeRef.current
            }
          >
            {formatMessage({ id: "global.btn.applyFilter" })}
          </Button>
        </Box>
      </Box>
    </PureModal>
  );
}
